import React from 'react';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toUnit } from '../../../utils/helpers/money';
import { getWps } from '../../../services/calc/wpsCalc';
import { useTypedSelector } from '../../../store';
import ResultRow from '../SumUpHead/ResultRow';
import { WpsTitle } from './WpsTitle';


const Wps = () => {
  const { overallInterestsSum, compensationSum, finalSum } = useTypedSelector(
    (state) =>
      state.sumUp,
    shallowEqual
  );
  const { t } = useTranslation();

  return (
    <>
      <WpsTitle title={t('wps.title')} />
      <ResultRow
        sum1={getWps(toUnit( finalSum))}
        sum2={getWps(toUnit(overallInterestsSum + finalSum))}
        sum3={getWps(toUnit(finalSum + compensationSum + overallInterestsSum))}
        legal={(
          <span>
            {t('wps.desc1')}
            <sup>1</sup>
            {t('wps.desc2')}
          </span>
        )}
      />
    </>
  );
};

export default Wps;
